import React from 'react';
import { MingaIcon } from './MingaLogo';
export function Navbar() {
  return <nav className="fixed top-0 left-0 right-0 z-50 bg-white/80 backdrop-blur-md border-b border-gray-100" data-id="element-125">
      <div className="max-w-5xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-126">
        <div className="flex items-center gap-2 font-bold text-xl tracking-tight text-gray-900" data-id="element-127">
          <MingaIcon size={32} data-id="element-128" />
          MINGA
        </div>
        <button className="text-sm font-medium text-white bg-brand-600 hover:bg-brand-700 px-5 py-2.5 rounded-full transition-colors" data-id="element-129">
          Empieza aquí
        </button>
      </div>
    </nav>;
}